export default {"src":"/oferta/_next/static/media/logo-purple.016fbe06.svg","height":64,"width":359,"blurWidth":0,"blurHeight":0};